import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs';
import { CaseInfoReferralResponse, CaseSearchEntry, ChargeGroupDto, Default_DefendatInfo, QuickUpdateDefendant_Request, ReferralInfoDetails, ReferralInfoTabsMeta, ReferralReviewDetail, ReferrealCharges, SaveReferralInfoRequestPayload, SubmitReferralDetailsRequestPayload } from '../referral-info/referral-info.model';
import { dateFromServerString, fileTooltipFromServerLinkTag, getServerLinkTagContent, normalizeServerString } from '../../../core/utils/convertors';
import { AuthService, Default_SessionUserDetails, SessionData_Response } from '../../../core/services/auth.service';
import { UserDefineField } from 'src/app/shared/models/models';
import { DefendantInfo } from 'src/app/core/models/models';
import { CivilCaseDefendantReferralResponse, DefendantCaseSearchResult, DefendantCodefndantSearchResult, DefendantWitnessSearchResult } from '../models/defendant.model';
import { CaseReferralChargeEnhancementOption, EnhancementModel, SaveChargeRequestPayload, SelectedEnhancementModel } from '../models/charge.model';
import { CivilCase, UserDefinedFieldModel } from '../civil-case-referral-page/models/civil-referral-case.model';
import { CaseConfig, CaseConfigData, CaseConfigField, CaseConfigSection, CaseConfigUserDefineField } from 'src/app/shared/models/civil-case.model';
import { CaseConfigTab } from 'src/app/shared/models/case-config-tab.model';
import { StepItemType } from '../models/referral-page.model';

@Injectable({ providedIn: 'root' })
export class ReferralInfoApiService {

    private baseUrl: string;
    private currentUser: SessionData_Response = Default_SessionUserDetails;
    constructor(private httpClient: HttpClient, private auth: AuthService,) {
        this.auth.currentSession$.subscribe((res) => {
            this.currentUser = res;
        });
        this.baseUrl = `${environment.api.url}WebServices`
    }

    public getReferralInfo(sequenceNumber: number) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetReferralInfo`
        return this.httpClient.post<string>(url, { sequenceNumber }, { params: { 'showLoader': true } }).pipe(map((res: string) => {
            const parsed = <CaseInfoReferralResponse>JSON.parse(res);

            const returnValue: ReferralInfoDetails = {
                DefendantInfo: {
                    ...Default_DefendatInfo,
                    intAddressFlag: parsed.DefendantInfo.IsIntl,
                    entityFlag: parsed.DefendantInfo.IsEntity,
                    lastName: normalizeServerString(parsed.DefendantInfo?.LastName) || '',
                    firstName: normalizeServerString(parsed.DefendantInfo?.FirstName) || '',
                    middleName: normalizeServerString(parsed.DefendantInfo?.MiddleName) || '',
                    nameSuffix: normalizeServerString(parsed.DefendantInfo?.NameSuffix) || '',
                    dateOfBirth: normalizeServerString(parsed.DefendantInfo?.DateOfBirth),
                    address1: normalizeServerString(parsed.DefendantInfo?.Address1) || '',
                    address2: normalizeServerString(parsed.DefendantInfo?.Address2) || '',
                    city: normalizeServerString(parsed.DefendantInfo?.City) || '',
                    state: normalizeServerString(parsed.DefendantInfo?.State) || '',
                    zipCode: normalizeServerString(parsed.DefendantInfo?.ZipCode) || '',
                    phone: normalizeServerString(parsed.DefendantInfo?.Phone) || '',
                    employer: normalizeServerString(parsed.DefendantInfo?.Agency) || '',
                    race: normalizeServerString(parsed.DefendantInfo?.Race) || '',
                    raceDescription: normalizeServerString(parsed.DefendantInfo?.RaceDescription) || '',
                    sex: normalizeServerString(parsed.DefendantInfo?.Sex) || '',
                    sexDescription: normalizeServerString(parsed.DefendantInfo?.SexDescription) || '',
                    height: normalizeServerString(parsed.DefendantInfo?.Height) || '',
                    weight: normalizeServerString(parsed.DefendantInfo?.Weight) || '',
                    hairColor: normalizeServerString(parsed.DefendantInfo?.Hair) || '',
                    hairColorDescription: normalizeServerString(parsed.DefendantInfo?.HairDescription) || '',
                    eyeColor: normalizeServerString(parsed.DefendantInfo?.Eyes) || '',
                    eyeColorDescription: normalizeServerString(parsed.DefendantInfo?.EyeDescription) || '',
                    nationality: normalizeServerString(parsed.DefendantInfo?.Nationality) || '',
                    nationalityDescription: normalizeServerString(parsed.DefendantInfo?.NationalityDescription) || '',
                    email: normalizeServerString(parsed.DefendantInfo?.Email) || '',
                    placeOfBirth: normalizeServerString(parsed.DefendantInfo?.PlaceOfBirth) || '',
                    placeOfBirthDescription: normalizeServerString(parsed.DefendantInfo?.PlaceOfBirthDescription) || '',
                    dlState: normalizeServerString(parsed.DefendantInfo?.LicenseState) || '',
                    dlNumber: normalizeServerString(parsed.DefendantInfo?.LicenseNumber) || '',
                    dLClassification: normalizeServerString(parsed.DefendantInfo?.LicenseClass) || '',
                    dLClassificationDescription: normalizeServerString(parsed.DefendantInfo?.LicenseClassDescription) || '',
                    dLExpirationDate: normalizeServerString(parsed.DefendantInfo?.LicenseExpirationDate),
                    ssn: normalizeServerString(parsed.DefendantInfo?.Ssn) || '',
                    sid: normalizeServerString(parsed.DefendantInfo?.StateId) || '',
                    fbiIdentifier: normalizeServerString(parsed.DefendantInfo?.FederalId) || '',
                    inmateNumber: normalizeServerString(parsed.DefendantInfo?.InmateNumber) || '',
                    defendantStatus: normalizeServerString(parsed.DefendantInfo?.DefendantStatus) || '',
                    defendantStatusDescription: normalizeServerString(parsed.DefendantInfo?.DefendantStatusDescription) || '',
                    lid: normalizeServerString(parsed.DefendantInfo?.LocalId) || '',
                    mugshotImage: parsed.DefendantInfo.MugshotUrl
                },
                ReferralInfo: parsed.ReferralInfo,
                TabsMeta: parsed.TabsMeta.map((tab) => {
                    return {
                        Type: this.getStepItemType(tab.Identifier),
                        Name: tab.Name,
                        HasData: tab.HasData
                    }
                }),
                CaseTypeId: parsed.CaseTypeId,
                IsCivilCase: parsed.IsCivilCase
            }
            return returnValue;
        }));
    }

    public continueDefendnatInfo(requestPayload: QuickUpdateDefendant_Request) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/ContinueDefendantForReferralInfo`
        return this.httpClient.post<string>(url, requestPayload, { params: { 'showLoader': true } });
    }

    public getReferralInfoTabDetails(sequenceNumber: number) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetReferralInfoTabDetails`
        return this.httpClient.post<ReferralInfoTabsMeta>(url, { sequenceNumber }, { params: { 'showLoader': true } });
    }

    public getReferralInfoCharges(sequenceNumber: number) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetReferralInfoCharges`
        return this.httpClient.post<Array<ChargeGroupDto>>(url, { sequenceNumber }, { params: { 'showLoader': true } });
    }

    public getReferralCharges(arrestSequenceNumber: number) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetReferralCharges`
        return this.httpClient.post<string>(url, { arrestSequenceNumber }, { params: { 'showLoader': true } }).pipe(map((res) => {
            if (res) {
                const charges = <ReferrealCharges[]>JSON.parse(res);
                const MIN_LENGTH = 10;

                return [
                    ...charges,
                    ...Array.from(
                        { length: Math.max(0, MIN_LENGTH - charges.length) },
                        () => ({ ...defaultCharge })
                    )
                ];
            } else {
                return [];
            }
        }));
    }

    public getDefendantCaseTabDetais(defendantId: string) {
        const url = `${this.baseUrl}/PartySearchResult.asmx/PersonSearchCaseSearch`;

        return this.httpClient.post<string>(url, {
            defendantNumberList: defendantId,
            userId: this.currentUser.UserId,
            caseStatus: '',
            reportNumber: '',
        }, { params: { 'showLoader': true } }).pipe(map(wrapper =>
            (<unknown[][]>JSON.parse(wrapper)).map(
                arr => <CaseSearchEntry>{
                    caseId: normalizeServerString(arr[10] as string) || '',
                    defendantNumber: arr[11] as number,
                    jurisdiction: normalizeServerString(arr[0] as string) || '',
                    causeNumber: normalizeServerString(arr[2] as string) || '',
                    fileNumber: getServerLinkTagContent(arr[1] as string) || '',
                    fileNumberTooltip: fileTooltipFromServerLinkTag(arr[1] as string) || '',
                    reportNumber: normalizeServerString(arr[3] as string) || '',
                    reportNumberTooltip: normalizeServerString(arr[13] as string) || '',
                    charge: normalizeServerString(arr[4] as string) || '',
                    chargeTooltip: normalizeServerString(arr[12] as string) || '',
                    caseType: normalizeServerString(arr[5] as string) || '',
                    issuedDate: normalizeServerString(arr[6] as string) || '',
                    status: normalizeServerString(arr[7] as string) || '',
                    stage: normalizeServerString(arr[8] as string) || '',
                    finalDispDate: normalizeServerString(arr[9] as string) || '',
                }
            )
        )
        );
    }

    public getDefendantWitnessTabDetais(defendantId: string) {
        const url = `${this.baseUrl}/PartySearchResult.asmx/PersonSearchWitnessCaseSearch`;

        return this.httpClient.post<string>(url, {
            defendantNumber: defendantId,
        }).pipe(map(wrapper =>
            (<unknown[][]>JSON.parse(wrapper)).map(
                arr => <CaseSearchEntry>{
                    caseId: normalizeServerString(arr[10] as string) || '',
                    defendantNumber: arr[11] as number,
                    jurisdiction: normalizeServerString(arr[0] as string) || '',
                    causeNumber: normalizeServerString(arr[2] as string) || '',
                    fileNumber: getServerLinkTagContent(arr[1] as string) || '',
                    fileNumberTooltip: fileTooltipFromServerLinkTag(arr[1] as string) || '',
                    reportNumber: normalizeServerString(arr[3] as string) || '',
                    reportNumberTooltip: normalizeServerString(arr[13] as string) || '',
                    charge: normalizeServerString(arr[4] as string) || '',
                    chargeTooltip: normalizeServerString(arr[12] as string) || '',
                    caseType: normalizeServerString(arr[5] as string) || '',
                    issuedDate: normalizeServerString(arr[6] as string) || '',
                    status: normalizeServerString(arr[7] as string) || '',
                    stage: normalizeServerString(arr[8] as string) || '',
                    finalDispDate: normalizeServerString(arr[9] as string) || '',
                }
            )
        )
        );
    }

    public getChargeEnhancementOptions(chargeCode: string) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetNCICList`

        return this.httpClient.post<string>(url, {
            whereCondition: `ChargeCode='${chargeCode}' Group By NcicCode, Description, LanguageFile `,
        }).pipe(map(wrapper => (<{ Code: string; EnactedDate: string; RepealedDate: string; Description: string; LanguageFile: string; }[]
            >JSON.parse(wrapper)).map(parsed => {
                return <CaseReferralChargeEnhancementOption>{
                    code: parsed.Code,
                    enacted: parsed.EnactedDate,
                    repealed: parsed.RepealedDate,
                    description: parsed.Description,
                    languageFile: parsed.LanguageFile,
                };
            })
        )
        );
    }

    public getSelectionEnhancementList(params: { selectedEnhCode: string; selectedChargeCode: string; arrestSequenceNumber: number; countNumber: number; whereCondition: string; }) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetEnhancementSelectionList`;

        return this.httpClient.post<string>(url, params, { params: { 'showLoader': true } }).pipe(
            map(wrapper => {
                const parsed = <{
                    EnhSeq: number;
                    Code: string;
                    MoRevisedStatute: string;
                    Description: string;
                    ChargeSeverityDescription: string;
                    EnactedDate: string;
                    RepealedDate: string;
                    UsageType: string;
                    CauseNumber: string;
                    DispositionCode: string;
                    SequenceNumber: string;
                    OldEnhSeq: number;
                    DispDesc: string;
                }[]>JSON.parse(wrapper);
                return parsed.map((item) => <SelectedEnhancementModel>{
                    code: item.Code,
                    statute: item.MoRevisedStatute,
                    usageType: item.UsageType,
                    enacted: item.EnactedDate,
                    repealed: item.RepealedDate,
                    description: item.Description,
                    severity: item.ChargeSeverityDescription,
                    sequenceNumber: item.EnhSeq,
                    courtNumber: item.CauseNumber,
                }
                );
            })
        );
    }

    public getEnhancementList(params: { iSearch: string; orderBy: number; sortDir: string; pageNumber: number; offenseFromDate: string; }) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetEnhancementList`;

        return this.httpClient.post<string>(url, params, { params: { 'showLoader': true } }).pipe(
            map(wrapper => {
                const parsed = <{ Enhancements: any[] }>JSON.parse(wrapper);

                return parsed.Enhancements.map(
                    (item: any) =>
                        <EnhancementModel>{
                            code: item.Code,
                            statute: item.MoRevisedStatute,
                            usageType: item.UsageType,
                            enacted: item.EnactedDate,
                            repealed: item.RepealedDate,
                            description: item.Description,
                            languageFile: item.LanguageFile,
                            languageFileTooltip: item.LanguageFileToolTip,
                            severity: item.ChargeSeverityDescription,
                        }
                );
            })
        );
    }

    public acceptEnhancementList(params: { arrestSequenceNumber: string; selectRow: string; chargeCode: string; counterNumber: number; userId: string; }) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/AcceptEnhancementSelectionList`;
        return this.httpClient.post<string>(url, params, { params: { 'showLoader': true } });
    }

    public saveReferralCharges(requestPayload: SaveChargeRequestPayload) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/SaveCharges`;

        return this.httpClient.post<string>(url, requestPayload, { params: { 'showLoader': true } }).pipe(map(res => {
            if (res) {
                const charges = <ReferrealCharges[]>JSON.parse(res);
                const MIN_LENGTH = 10;

                return [
                    ...charges,
                    ...Array.from(
                        { length: Math.max(0, MIN_LENGTH - charges.length) },
                        () => ({ ...defaultCharge })
                    )
                ];
            } else {
                return [];
            };
        })
        );
    }

    public getReviewData(sequenceNumber: number) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetReferralReviewData`;

        return this.httpClient.post<ReferralReviewDetail>(url, { sequenceNumber }, { params: { 'showLoader': true } });
    }

    public saveReferralInfo(requestPayload: SaveReferralInfoRequestPayload) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/QuickUpdateReferralInfo`;

        return this.httpClient.post<string>(url, { request: requestPayload }, { params: { 'showLoader': true } });
    }

    public getDefendantSearchResultAllTabData(defendantNumber: number) {
        const url = `${this.baseUrl}/WitnessSearchResult.asmx/GetDefendantSearchResultAllTabData`;

        return this.httpClient.post<string>(url, { defendantNumber }).pipe(map((res) => {
            const parsedResponse = <string[]>JSON.parse(res);

            const defendantList = (<unknown[][]>JSON.parse(parsedResponse[0])).map((def) => {
                return <DefendantCaseSearchResult>{
                    Jurisdiction: def[0],
                    FileNumber: def[1],
                    CauseNumber: def[2],
                    ChargeDescription: def[3],
                    Severity: def[4],
                    OffenseFromDate: def[5],
                    Status: def[6],
                    Stage: def[7],
                    DispositionDate: def[8],
                    IsAuthorized: def[9],
                    ChargeDescriptionTooltip: def[10],
                }
            });
            const witnessList = (<unknown[][]>JSON.parse(parsedResponse[1])).map((wit) => {
                return <DefendantWitnessSearchResult>{
                    Jurisdiction: wit[0],
                    FileNumber: wit[1],
                    CauseNumber: wit[2],
                    ReportNumber: wit[3],
                    Defendant: wit[4],
                    Race: wit[5],
                    Sex: wit[6],
                    DateOfBirth: wit[7],
                    WitnessType: wit[8],
                    DocketCode: wit[9],
                    NextDocketDate: wit[10],
                    Stage: wit[11],
                }
            });
            const codefList = (<unknown[][]>JSON.parse(parsedResponse[2])).map((codef) => {
                return <DefendantCodefndantSearchResult>{
                    Jurisdiction: codef[0],
                    FileNumber: codef[1],
                    OtherFileNumber: codef[2],
                    OffenseFromDate: codef[3],
                    CodefendantName: codef[4],
                    ChargeDescription: codef[5],
                    Stage: codef[6]
                }
            });;
            return { defendantList, witnessList, codefList };
        }));
    }

    public referAndSubmitReferralDetails(requestPayload: SubmitReferralDetailsRequestPayload) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/SubmitReferralCase`;

        return this.httpClient.post<string>(url, requestPayload, { params: { 'showLoader': true } });
    }

    public getCivilCaseReferralConfigs(casePageTypeId: string, sequenceNumber: string) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetReferralCivilCaseFieldConfigs`;

        return this.httpClient.post<string>(url, { casePageTypeId, sequenceNumber }, { params: { 'showLoader': true } })
            .pipe(
                map(wrapper => {
                    const parsed = <
                        {
                            TemplateTitle: string;
                            TemplateId: number;
                            IsCivil: boolean;
                            Sections: { Id: string; ParentId: string; Width: string }[];
                            Fields: {
                                Id: number;
                                SectionId: string;
                                Label: string;
                                Order: number;
                                Width: number;
                            }[];
                            UserDefinedFields: {
                                Id: number;
                                SectionId: string;
                                Label: string;
                                Order: number;
                                FieldType: number;
                                IsDisabled: boolean;
                                Width: number;
                            }[];
                            Tabs: { Identifier: string; Name: string; HasData: boolean }[];
                        }>JSON.parse(wrapper);

                    return <CaseConfig>{
                        templateTitle: parsed.TemplateTitle,
                        templateId: parsed.TemplateId,
                        isCivil: parsed.IsCivil,
                        sections: parsed.Sections.map(
                            section =>
                                <CaseConfigSection>{
                                    id: section.Id,
                                    parentId: section.ParentId,
                                    width: section.Width,
                                }
                        ),
                        fields: parsed.Fields.map(
                            field =>
                                <CaseConfigField>{
                                    id: field.Id,
                                    sectionId: field.SectionId,
                                    label: field.Label,
                                    order: field.Order,
                                    width: field.Width,
                                }
                        ),
                        userDefinedFields: parsed.UserDefinedFields.map(
                            udField =>
                                <CaseConfigUserDefineField>{
                                    id: udField.Id,
                                    sectionId: udField.SectionId,
                                    label: udField.Label,
                                    order: udField.Order,
                                    isDisabled: udField.IsDisabled,
                                    type: udField.FieldType,
                                    width: udField.Width,
                                }
                        ),
                        tabs: parsed.Tabs.map(
                            t =>
                                <CaseConfigTab>{
                                    identifier: normalizeServerString(t.Identifier),
                                    name: normalizeServerString(t.Name),
                                    hasData: t.HasData,
                                }
                        ),
                    };
                })
            );
    }

    public getUserDefineCaseConfigControlsDataReferral(sequenceNumber: string) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetCaseConfigUserDefineControlsDataReferral`;
        return this.httpClient.post<string>(url, { arrestSequenceNumber: sequenceNumber }, { params: { 'showLoader': true } })
            .pipe(map(wrapper =>
                (<{ FieldName: string; FieldValue: string }[]>JSON.parse(wrapper)).map(parsed => {
                    return <UserDefineField>{
                        name: normalizeServerString(parsed.FieldName),
                        value: normalizeServerString(parsed.FieldValue),
                    };
                })
            )
            );
    }

    public getCaseConfigControlsDataReferral(sequenceNumber: string) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetCaseConfigControlsDataReferral`;

        return this.httpClient.post<string>(url, { arrestSequenceNumber: sequenceNumber }, { params: { 'showLoader': true } })
            .pipe(map(wrapper => {
                const parsed = <
                    {
                        caseInfoData: {
                            PaFile1: string;
                            PaFile2: string;
                            ReportNo: string;
                            DefenseAttorney: string;
                            ReportNumber: string;
                            LeAgency: string;
                            Ocn: string;
                            LabNumber: string;
                            ArrestNumber: string;
                            AccidentFlag: string;
                            AccidentNumber: string;
                            ClockedSpeed: number;
                            PostedSpeed: number;
                            MphOver: string;
                            VehicleMake: string;
                            VehicleModel: string;
                            VehicleVIN: string;
                            VehicleYear: string;
                            VehicleColor: string;
                            VehicleLicense: string;
                            VehicleState: string;
                            VehicleLicExpYr: string;
                            VehicleRegWeight: number;
                            VehicleActWeight: number;
                            Status: string;
                            FatalityFlag: boolean;
                            LicenseSurrenderFlag: boolean;
                            IgnitionInterlockFlag: boolean;
                            AssignedName: string | null;
                            AssignedEmail: string | null;
                            AssignedEmailHref: string | null;
                            ConstructionZoneFlag: boolean;
                            SignWorkFlag: boolean;
                            TravelSafeZoneFlag: boolean;
                            DWIFlag: boolean;
                            CommVehFlag: boolean;
                            VehicleOperationFlag: boolean;
                            DWITestAgency: string;
                            DWITestType: string;
                            BloodAlcoholContent: string;
                            InstrumentNo: string;
                            CertificationDate: string;
                            CertificationDateString: string;
                            SimulatorNumber: string;
                            CivilMatter: string;
                            CivilType: string;
                            CivilNumber: string;
                            CivilDescription: string;
                            CivilClient: string;
                            CivilClientDescription: string;
                            CivilWork: string;
                            CivilArea: string;
                            CivilFunded: string;
                            CivilCats: string;
                            CivilDisposition: string;
                            CivilExplanation: string;
                            CaseCategory: string;
                            CauseNumber: string;
                            CaseWeight: number;
                            ProSe: boolean;
                            DefensePdRetainer: string;
                            JurisdictionCode: string;
                            NeighborhoodCode: string;
                            BookingPd: string;
                            PdNumber: string;
                            IsShowBondInfo: boolean;
                            ArrestDateValue: string;
                            ArrestTimeValue: string;
                            DsnSequence: string;
                            PoBadgeNumber: string;
                            IssuedDateValue: string;
                            Phone: string | null;
                            CaseWorkerLabel: string;
                            Address: string | null;
                            TicketNumber: string;
                            SummonDate: string;
                            SummonNum: string;
                        };
                        CaseChildHasValue: {
                            TotalReportNumbers: number;
                            TotalDefCoCounsel: number;
                            TotalCaseNote: number;
                        };
                        DSN: string;
                        DefenseAttyNameToolTip: string;
                        chk24HourHoldTimeDiff: string;
                        HourlyHoldAmount: string;
                        Hold24Hour: boolean;
                        BookingPDToolTip: string;
                        NeighborhoodToolTip: string;
                        CategoryToolTip: string;
                        StageDescription: string;
                        CaseWeightToolTip: string;
                        BadgeNumberToolTip: string;
                        OcnToolTip: string;
                        JurisdictionCodeToolTip: string;
                        CauseNoToolTip: string;
                        ReportNoToolTip: string;
                        LabNumberToolTip: string;
                        DSNToolTip: string;
                        ReferralDate: string;
                        ReportReceivedDate: string;
                        ArrestDate: string;
                        ArrestTime: string;
                        LEAgencyToolTip: string;
                        StageCode: string
                        StageCodeDescription: string
                        DocCategory: string;
                        DWITestAgencyTooltip: string;
                    }
                    >JSON.parse(wrapper);

                return <CaseConfigData>{
                    fileNumber: {
                        prefix: normalizeServerString(parsed.caseInfoData.PaFile1),
                        suffix: normalizeServerString(parsed.caseInfoData.PaFile2),
                    },
                    assigned: !!parsed.caseInfoData.AssignedName
                        ? {
                            name: normalizeServerString(parsed.caseInfoData.AssignedName),
                            email: normalizeServerString(parsed.caseInfoData.AssignedEmail),
                            emailHref: normalizeServerString(parsed.caseInfoData.AssignedEmailHref),
                            phone: normalizeServerString(parsed.caseInfoData.Phone),
                            address: normalizeServerString(parsed.caseInfoData.Address),
                        }
                        : null,
                    reportNo: {
                        value: normalizeServerString(
                            parsed.caseInfoData.ReportNo || parsed.caseInfoData.ReportNumber
                        ),
                        tooltip: normalizeServerString(parsed.ReportNoToolTip),
                    },
                    reportNumber: normalizeServerString(parsed.caseInfoData.ReportNumber),
                    referralDate: normalizeServerString(parsed.ReferralDate),
                    reportReceivedDate: normalizeServerString(parsed.ReportReceivedDate),
                    dsn: {
                        dsnSequence: parsed.caseInfoData?.DsnSequence || '',
                        value: normalizeServerString(`${parsed.DSN}:${parsed.caseInfoData?.DsnSequence}`),
                        tooltip: normalizeServerString(parsed.DSNToolTip),
                    },
                    agency: {
                        description: normalizeServerString(parsed.LEAgencyToolTip) || normalizeServerString(parsed.caseInfoData.PdNumber),
                        value: normalizeServerString(parsed.caseInfoData.PdNumber) || ''
                    },
                    ocn: {
                        value: normalizeServerString(parsed.caseInfoData.Ocn),
                        tooltip: normalizeServerString(parsed.OcnToolTip),
                    },
                    labNumber: {
                        value: normalizeServerString(parsed.caseInfoData.LabNumber),
                        tooltip: normalizeServerString(parsed.LabNumberToolTip),
                    },
                    arrest: {
                        number: normalizeServerString(parsed.caseInfoData.ArrestNumber),
                        date: normalizeServerString(parsed.caseInfoData.ArrestDateValue),
                        time: normalizeServerString(parsed.caseInfoData.ArrestTimeValue),
                    },
                    hourHold: {
                        value: parsed.Hold24Hour,
                        timeDiff: normalizeServerString(parsed.chk24HourHoldTimeDiff),
                        amount: normalizeServerString(parsed.HourlyHoldAmount),
                    },
                    bookingPD: {
                        description: normalizeServerString(parsed.BookingPDToolTip) || normalizeServerString(parsed.caseInfoData.BookingPd),
                        value: normalizeServerString(parsed.caseInfoData.BookingPd)
                    },
                    neighborhood: {
                        tooltip: normalizeServerString(parsed.NeighborhoodToolTip),
                        code: normalizeServerString(parsed.caseInfoData.NeighborhoodCode),
                    },
                    ticketNumber: normalizeServerString(parsed.caseInfoData.TicketNumber),
                    accident: {
                        flag: normalizeServerString(parsed.caseInfoData.AccidentFlag),
                        number: normalizeServerString(parsed.caseInfoData.AccidentNumber),
                    },
                    clockedSpeed: parsed.caseInfoData.ClockedSpeed,
                    postedSpeed: parsed.caseInfoData.PostedSpeed,
                    mphOver: normalizeServerString(parsed.caseInfoData.MphOver),
                    vehicle: {
                        make: normalizeServerString(parsed.caseInfoData.VehicleMake),
                        model: normalizeServerString(parsed.caseInfoData.VehicleModel),
                        vin: normalizeServerString(parsed.caseInfoData.VehicleVIN),
                        year: normalizeServerString(parsed.caseInfoData.VehicleYear),
                        color: normalizeServerString(parsed.caseInfoData.VehicleColor),
                        license: normalizeServerString(parsed.caseInfoData.VehicleLicense),
                        state: normalizeServerString(parsed.caseInfoData.VehicleState),
                        licenseExpirationYear: normalizeServerString(parsed.caseInfoData.VehicleLicExpYr),
                        registrationWeight: parsed.caseInfoData.VehicleRegWeight,
                        actualWeight: parsed.caseInfoData.VehicleActWeight,
                    },
                    isFatality: parsed.caseInfoData.FatalityFlag,
                    isLicenseSurrender: parsed.caseInfoData.LicenseSurrenderFlag,
                    isIgnitionInterlock: parsed.caseInfoData.IgnitionInterlockFlag,
                    isConstructionZone: parsed.caseInfoData.ConstructionZoneFlag,
                    isSignWork: parsed.caseInfoData.SignWorkFlag,
                    isTravelSafeZone: parsed.caseInfoData.TravelSafeZoneFlag,
                    isDWI: parsed.caseInfoData.DWIFlag,
                    isVehicleOperation: parsed.caseInfoData.VehicleOperationFlag,
                    isCommVeh: parsed.caseInfoData.CommVehFlag,
                    dwiTest: {
                        agency: normalizeServerString(parsed.caseInfoData.DWITestAgency),
                        tooltip: normalizeServerString(parsed.DWITestAgencyTooltip || parsed.caseInfoData.DWITestAgency),
                        type: normalizeServerString(parsed.caseInfoData.DWITestType),
                    },
                    bloodAlcoholContent: normalizeServerString(parsed.caseInfoData.BloodAlcoholContent),
                    instrumentNo: normalizeServerString(parsed.caseInfoData.InstrumentNo),
                    certificationDate: normalizeServerString(parsed.caseInfoData.CertificationDateString),
                    simulatorNumber: normalizeServerString(parsed.caseInfoData.SimulatorNumber),
                    causeNumber: {
                        value: normalizeServerString(parsed.caseInfoData.CauseNumber),
                        tooltip: normalizeServerString(parsed.CauseNoToolTip),
                    },
                    civil: {
                        matter: normalizeServerString(parsed.caseInfoData.CivilMatter),
                        type: normalizeServerString(parsed.caseInfoData.CivilType),
                        number: normalizeServerString(parsed.caseInfoData.CivilNumber),
                        description: normalizeServerString(parsed.caseInfoData.CivilDescription),
                        client: normalizeServerString(parsed.caseInfoData.CivilClient),
                        clientDescription: normalizeServerString(parsed.caseInfoData.CivilClientDescription),
                        work: normalizeServerString(parsed.caseInfoData.CivilWork),
                        area: normalizeServerString(parsed.caseInfoData.CivilArea),
                        funded: normalizeServerString(parsed.caseInfoData.CivilFunded),
                        cats: normalizeServerString(parsed.caseInfoData.CivilCats),
                        disposition: normalizeServerString(parsed.caseInfoData.CivilDisposition),
                        explanation: normalizeServerString(parsed.caseInfoData.CivilExplanation),
                    },
                    category: {
                        value: normalizeServerString(parsed.caseInfoData.CaseCategory),
                        tooltip: normalizeServerString(parsed.CategoryToolTip),
                    },
                    stageDescription: normalizeServerString(parsed.StageDescription),
                    weight: {
                        value: parsed.caseInfoData.CaseWeight,
                        tooltip: normalizeServerString(parsed.CaseWeightToolTip),
                    },
                    badgeNumber: normalizeServerString(parsed.BadgeNumberToolTip),
                    proSe: parsed.caseInfoData.ProSe,
                    defense: {
                        attorney: normalizeServerString(parsed.caseInfoData.DefenseAttorney),
                        attorneyName: normalizeServerString(parsed.DefenseAttyNameToolTip),
                        pdRetainer: normalizeServerString(parsed.caseInfoData.DefensePdRetainer),
                    },
                    jurisdiction: {
                        id: normalizeServerString(parsed.caseInfoData.JurisdictionCode),
                        codeTooltip: normalizeServerString(parsed.JurisdictionCodeToolTip),
                    },
                    isShowBond: parsed.caseInfoData.IsShowBondInfo,
                    totals: {
                        caseNote: parsed.CaseChildHasValue.TotalCaseNote,
                        defCoCounsel: parsed.CaseChildHasValue.TotalDefCoCounsel,
                        reportNumbers: parsed.CaseChildHasValue.TotalReportNumbers,
                    },
                    status: normalizeServerString(parsed.caseInfoData?.Status),
                    poBadgeNumber: normalizeServerString(parsed.caseInfoData?.PoBadgeNumber),
                    courtNumber: normalizeServerString(parsed.caseInfoData?.CauseNumber),
                    issuedDate: normalizeServerString(parsed.caseInfoData.IssuedDateValue),
                    stageCode: normalizeServerString(parsed.StageCode),
                    stageCodeDescription: normalizeServerString(parsed.StageCodeDescription) || parsed.StageCode,
                    docCategory: normalizeServerString(parsed.DocCategory),
                    summonDate: normalizeServerString(parsed.caseInfoData.SummonDate),
                    summonNum: normalizeServerString(parsed.caseInfoData.SummonNum),
                };
            })
            );
    }

    public getCivilDefendantInfo(sequenceNumber: number) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/GetCivilDefendantInfo`;
        return this.httpClient.post<string>(url, { sequenceNumber }, { params: { 'showLoader': true } }).pipe(
            map(wrapper => {
                const parsed = <CivilCaseDefendantReferralResponse>JSON.parse(wrapper);
                const value: DefendantInfo = {
                    ...Default_DefendatInfo,
                    defendantNumber: parsed.DefendantInfo?.DefendantNumber || 0,
                    firstName: normalizeServerString(parsed.DefendantInfo?.FirstName) || '',
                    middleName: normalizeServerString(parsed.DefendantInfo?.MiddleName) || '',
                    lastName: normalizeServerString(parsed.DefendantInfo?.LastName) || '',
                    // namePrefix: normalizeServerString(parsed.DefendantInfo?.NamePrefix) || '',
                    nameSuffix: normalizeServerString(parsed.DefendantInfo?.NameSuffix) || '',
                    address1: normalizeServerString(parsed.DefendantInfo?.Address1) || '',
                    address2: normalizeServerString(parsed.DefendantInfo?.Address2) || '',
                    city: normalizeServerString(parsed.DefendantInfo?.City) || '',
                    state: normalizeServerString(parsed.DefendantInfo?.State) || '',
                    zipCode: normalizeServerString(parsed.DefendantInfo?.ZipCode) || '',
                    employer: normalizeServerString(parsed.DefendantInfo?.Agency) || '',
                    dateOfBirth: (parsed.DefendantInfo?.DateOfBirth) || '',
                    placeOfBirth: normalizeServerString(parsed.DefendantInfo?.PlaceOfBirth) || '',
                    placeOfBirthDescription: normalizeServerString(parsed.DefendantInfo?.PlaceOfBirthDescription) || '',
                    eyeColor: normalizeServerString(parsed.DefendantInfo?.Eyes) || '',
                    eyeColorDescription: normalizeServerString(parsed.DefendantInfo?.EyeDescription) || '',
                    hairColor: normalizeServerString(parsed.DefendantInfo?.Hair) || '',
                    hairColorDescription: normalizeServerString(parsed.DefendantInfo?.HairDescription) || '',
                    height: normalizeServerString(parsed.DefendantInfo?.Height) || '',
                    weight: normalizeServerString(parsed.DefendantInfo?.Weight) || '',
                    sex: normalizeServerString(parsed.DefendantInfo?.Sex) || '',
                    sexDescription: normalizeServerString(parsed.DefendantInfo?.SexDescription) || '',
                    race: normalizeServerString(parsed.DefendantInfo?.Race) || '',
                    raceDescription: normalizeServerString(parsed.DefendantInfo?.RaceDescription) || '',
                    nationality: normalizeServerString(parsed.DefendantInfo?.Nationality) || '',
                    nationalityDescription: normalizeServerString(parsed.DefendantInfo?.NationalityDescription) || '',
                    phone1: normalizeServerString(parsed.DefendantInfo?.Phone) || '',
                    dlNumber: normalizeServerString(parsed.DefendantInfo?.LicenseNumber) || '',
                    dlState: normalizeServerString(parsed.DefendantInfo?.LicenseState) || '',
                    dLClassification: normalizeServerString(parsed.DefendantInfo?.LicenseClass) || '',
                    dLClassificationDescription: normalizeServerString(parsed.DefendantInfo?.LicenseClassDescription) || '',
                    dLExpirationDate: normalizeServerString(parsed.DefendantInfo?.LicenseExpirationDate) || '',
                    defendantStatus: normalizeServerString(parsed.DefendantInfo?.DefendantStatus) || '',
                    defendantStatusDescription: normalizeServerString(parsed.DefendantInfo?.DefendantStatusDescription) || '',
                    ssn: normalizeServerString(parsed.DefendantInfo?.Ssn) || '',
                    sid: normalizeServerString(parsed.DefendantInfo?.StateId) || '',
                    lid: normalizeServerString(parsed.DefendantInfo?.LocalId) || '',
                    fbiIdentifier: normalizeServerString(parsed.DefendantInfo?.FederalId) || '',
                    inmateNumber: normalizeServerString(parsed.DefendantInfo?.InmateNumber) || '',
                    // childID: normalizeServerString(parsed.DefendantInfo?.ChildId) || '',
                    email: normalizeServerString(parsed.DefendantInfo.Email),
                    entityFlag: parsed.DefendantInfo.IsEntity,
                    intAddressFlag: parsed.DefendantInfo.IsIntl,
                    phone: normalizeServerString(parsed.DefendantInfo.Phone),
                    mugshotImage: parsed.DefendantInfo.MugshotUrl,
                };
                return value;
            })
        );
    }

    public checkCaseReferralStatus(sequenceNumber: string) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/checkCaseReferralStatus`;

        return this.httpClient.post<string>(url, { sequenceNumber: sequenceNumber }, { params: { showLoader: true } });
    }

    public referCivilCase(requestPayload: { civilCase: CivilCase; userDefinedFields: UserDefinedFieldModel[]; sequenceNumber: string; }) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/SubmitReferralCivilCase`;

        return this.httpClient.post<string>(url, requestPayload, { params: { 'showLoader': true } });
    }

    public updateReferralInfo(params: { civilReferral: CivilCase; userDefinedFields: UserDefinedFieldModel[]; caseSequenceNumber: number; }) {
        const url = `${this.baseUrl}/CaseInfo.asmx/QuickUpdateCivilCaseInfoReferral`;

        return this.httpClient.post<string>(url, {
            civilCase: params.civilReferral,
            userDefinedFields: params.userDefinedFields,
            caseSequenceNumber: params.caseSequenceNumber
        }, { params: { 'showLoader': true } });
    }

    public updateReferralInfoTab(requestPayload: { SequenceNumber: number, infoTab: StepItemType | null }) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/UpdateCivilReferralInfoTab`;

        return this.httpClient.post<string>(url, requestPayload);
    }

    public uploadMugshot(params: { file: File; arrestSeqNumber: string }) {
        const url = `${this.baseUrl}/DocumentsBrowser.asmx/UploadDocumentMugshot`;

        const formData = new FormData();
        formData.append('file', params.file, params.file.name);
        formData.append('arrestSeqNumber', params.arrestSeqNumber);

        return this.httpClient.post<void>(url, formData);
    }

    public removeMugShot(arrestSeqNumber: number) {
        const url = `${this.baseUrl}/DocumentsBrowser.asmx/RemoveMugShot`;

        return this.httpClient.post<void>(url, { arrestSeqNumber });
    }

    public checkChargesForCodefndant(Cnt: string, ArrestSequence: number) {
        const url = `${this.baseUrl}/CaseInfoReferral.asmx/CheckChargesForCodefndant`;

        return this.httpClient.post<boolean>(url, { ArrestSequence, Cnt });
    }

    private getStepItemType(identifier: string) {
        let stepItemtype = StepItemType.ReviewSubmit;
        switch (identifier) {
            case "CHARGE":
                stepItemtype = StepItemType.Charge
                break;
            case "WITNESS":
                stepItemtype = StepItemType.Witness
                break;
            case "DOCUMENT":
                stepItemtype = StepItemType.Document
                break;
            case "CODEFENDANT":
                stepItemtype = StepItemType.CoDefendant
                break;

        }
        return stepItemtype;
    }
}

const defaultCharge: ReferrealCharges = {
    OffenseFromDate: '',
    ChargeDescriptionDisplayString: '',
    TicketNumber: '',
    OffenseStreetAddress1: '',
    OffenseCity: '',
    CountNumber: '',
    hdnOffenseFromDate: '',
    OffenseToDate: '',
    ReferralChargeDescription: '',
    ChargeCode: '',
    Statute: '',
    ChargeModifier: '',
    ChargeDescription: '',
    OffenseState: '',
    OffenseZipCode: '',
    ChargeTypeClass: '',
    ItemNumber: '',
    IsEdit: false,
    ChargeNcic: ''
}